import { useField } from "formik";
import CheckboxNodeType from "../../types/CheckboxNodeType";
import MuiCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export const Checkbox = ({ name, label, inline, sx, labelSx, ...props }: CheckboxNodeType & any) => {
    const [field] = useField(name);

    return (
        <FormControlLabel
            sx={{
                ...(inline ? { display: "inline-flex", mr: 2 } : {}),
                ...sx,
            }}
            control={
                <MuiCheckbox
                    checked={!!field?.value}
                    {...props}
                    onChange={(e: any) => {
                        field?.onChange({
                            target: {
                                name,
                                value: !!e?.target?.checked,
                            },
                        });
                    }}
                />
            }
            label={label}
            slotProps={{
                typography: {
                    sx: labelSx,
                },
            }}
        />
    );
};

export default Checkbox;
